import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const HUB_DASHBOARD = "https://domio.com.pl/dashboard";

export default function NoModuleAccess() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <main className="flex flex-1 flex-col items-center justify-center px-4">
        <h1 className="mb-2 text-center text-3xl font-black tracking-tight text-foreground sm:text-4xl">
          DOMIO <span className="text-primary">Cleaning</span>
        </h1>
        <Card className="mt-8 w-full max-w-md border-border/50 bg-card/80">
          <CardContent className="flex flex-col items-center gap-6 p-8">
            <p className="text-center text-lg font-semibold">Brak dostępu do aplikacji Cleaning</p>
            <p className="text-center text-sm text-muted-foreground">
              Twoja organizacja nie ma aktywnej subskrypcji tego modułu. Wróć do panelu DOMIO i
              otwórz wykupione aplikacje albo wybierz plan Cleaning.
            </p>
            <Button asChild size="lg" className="w-full rounded-2xl">
              <a href={HUB_DASHBOARD}>Wróć do panelu DOMIO</a>
            </Button>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
